<template>
  <div class="left-menu">
    <router-link class="block pt-4 pb-3" :to="{ name: 'acticsLandingPage' }">
      <v-icon class="font-18px" color="black">mdi-home-outline</v-icon>
    </router-link>
    <v-divider />
    <template v-if="hasAppSlot">
      <div class="app-home hvh-flex center align-center">
        <slot name="app" />
      </div>
      <v-divider />
    </template>
    <template v-if="hasDefaultSlot">
      <div class="hvh-flex column links-box">
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  noExport: true,
  data() {
    return {
      hasAppSlot: false,
      hasDefaultSlot: false,
    };
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisActicsLeftMenu'] = this;
    this.hasAppSlot = this.$slots.app;
    this.hasDefaultSlot = this.$slots.default;
  },
}
</script>

<style lang="scss" scoped>
.left-menu {
  background-color: var(--bg-color-3);
  text-align: center;
  min-width: 43px;
  min-height: 100%;
  transition: 0.4s ease-in-out;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  z-index: 1;
  .links-box {
    background-color: rgba(81, 116, 123, 0.07);

    .action-link {
      padding: 6px 4px;
      margin: 4px 4px 0;
      &.active {
        border-radius: 7px;
        background-color: rgba(133, 199, 211, 0.23);
      }
    }
    a,
    span {
      color: #04051f !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.app-home {
  min-height: 53px;
}
</style>